<div class="row">
  <div class="twelve columns">
    <h2 class="fieldset-title" style="font-size: x-large;">RoleType PayCurve Mappings</h2>
  </div>
</div>
<div class="row">
  <div class="twelve columns">
    <div class="two columns">
      <button soho-button="secondary" icon="refresh" (click)="GetRolePayCurveMappings()">Refresh</button>
    </div>
    <div class="two columns">
      <button soho-button="primary" icon="plus" (click)="AddNew()" soho-tooltip
        title="Add a new mapping."><span>Add New</span></button>
    </div>
    <div class="two columns">
      <button soho-button="primary" icon="delete-grid-row" (click)="DeleteMappings()" soho-tooltip
        title="Delete selected mapping(s)."><span>Delete</span></button>
    </div>
  </div>
</div>
<div class="row top-padding" soho-busyindicator [blockUI]="true" [text]="Message">
  <div class="twelve columns demo" role="main">
    <div soho-datagrid [columns]="grid_Columns" id="RolePayCurveMappingGrid" [data]="data" [selectable]="'multiple'"
      [paging]="true" [pagesize]="25" filterable="true" [clickToSelect]="false" [toolbar]="{results: true}"></div>
  </div>
</div>
